module.exports = __webpack_public_path__ + "img/pztype-1.39824bec.png";